export default {
  'dashboard.alert.timezone':
    'Please confirm your local timezone to help us provide smarter date & time information.',
  'dashboard.timezone': 'Local timezone',
};
